/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which harmony should I use?`)
};

const es_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué armonía debería usar?`)
};

const de_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Harmonie sollte ich verwenden?`)
};

const nl_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke harmonie moet ik gebruiken?`)
};

const fr_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle harmonie devrais-je utiliser ?`)
};

const it_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale armonia dovrei usare?`)
};

const pt_br2_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual harmonia devo usar?`)
};

const pt_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que harmonia devo usar?`)
};

const ja_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの配色ルールを使うべきですか?`)
};

const zh_cp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我该使用哪种配色方案？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_q2", locale)
	if (locale === "en") return en_cp_faq_q2(inputs)
	if (locale === "es") return es_cp_faq_q2(inputs)
	if (locale === "de") return de_cp_faq_q2(inputs)
	if (locale === "nl") return nl_cp_faq_q2(inputs)
	if (locale === "fr") return fr_cp_faq_q2(inputs)
	if (locale === "it") return it_cp_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_q2(inputs)
	if (locale === "pt") return pt_cp_faq_q2(inputs)
	if (locale === "ja") return ja_cp_faq_q2(inputs)
	return zh_cp_faq_q2(inputs)
};